//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loader from 'vue-spinner/src/BounceLoader.vue'
import MSelect from '../components/MSelect'

export default {
  name: 'catalog',
  props: ['accent_color','accent_color_class','catalog_type'],
  components: { MSelect, Loader },
  data() {
    return {
      categories: [],
      subcategories: [],
      products: [],
      page_count: 0,
      selected_cat: false,
      selected_subcat: false,
      selected_brands: [],
      first_cat: false,
      first_subcat: false,
      loading: false,
      current_page: Number(this.$route.query.page),
      current_scope: 'show_mvgd_lt',
    }
  },
  created() {
    this.set_query_params();
    this.get_categories();
  },
  watch: {
    '$route': function() {
      this.set_query_params();
      this.get_categories();
    },
  },
  methods: {
    change_page(page) {
      this.change_param('page', page);
    },
    change_param(param_type, param) {
      if ( param_type === 'category' ) {

        this.$router.push({
          query: {
            [param_type]: param,
            distribution_category: this.current_scope,
            page: 1,
            lang: this.app.lang,
          }
        });

        this.selected_subcat = false;
        this.current_page = 1;

      } else {
        if ( !this.isEquivalent( { ...this.$route.query, [param_type]: param }, {...this.$route.query} ) ) {
          this.$router.push({
            query: {
              ...this.$route.query,
              [param_type]: param,
              page: 1,
              lang: this.app.lang,
            }
          });
        }
      }
    },
    set_query_params() {
      if ( typeof this.$route.query.category !== "undefined" ) {
        this.selected_cat = this.$route.query.category;
      }

      if ( typeof this.$route.query.subcategory !== "undefined" ) {
        this.selected_subcat = this.$route.query.subcategory;
      }

      if ( typeof this.$route.query.pt_brands !== "undefined" ) {
        this.selected_brands = this.$route.query.pt_brands.split(',');
      }

      if ( typeof this.$route.query.distribution_category !== "undefined" ) {
        this.current_scope = this.$route.query.distribution_category;
      }

      this.current_page = this.$route.query.page;
    },
    get_categories() {
      this.$http.get(`${this.app.api_url}/mv/product-categories`).then((response) => {
        this.categories = response.data;
        const [first_category_item] = this.categories.filter((obj) => obj.parent == 0);
        this.first_cat = first_category_item;

        if ( !Object.entries(this.$route.query).length ) {
          this.$router.push({
            query: {
              category: this.first_cat.term_id,
              distribution_category: 'show_mvgd_lt',
              page: 1,
              lang: this.app.lang,
            },
          });
        }

        if ( typeof this.$route.query.category === "undefined"  ) {
          this.$router.push({
            query: {
              category: this.first_cat.term_id,
              distribution_category: this.current_scope,
              page: 1,
              lang: this.app.lang,
            },
          });
        }

      }).then(() => {
        this.get_products();
      });
    },
    get_products() {
      const query_params = Object.keys(this.$route.query).map(key => key + '=' + this.$route.query[key]).join('&');
      this.loading = true;

      this.$http.get(`${this.app.api_url}/mv/products?${query_params}`).then((response) => {
        this.products = response.data;
        this.page_count = response.data.page_count;
        this.loading = false;
      });
    },

    get_akeneo_categories() {
      this.loading = true;

      this.$http.get(`${this.app.api_url}/akeneo/categories?lang=${this.app.lang}`).then((response) => {
        this.categories = response.data;

        const [first_category_item] = this.categories;
        this.first_cat = first_category_item;

        if ( !Object.entries(this.$route.query).length ) {
          this.$router.push({
            query: {
              category: this.first_cat.name,
              scope: 'MV_LT',
            },
          });
        }
      }).then(() => {
        const [subcategories] = this.categories.filter((obj) => obj.name === this.selected_cat);
        this.subcategories = subcategories.data;
      }).then(() => {
        this.get_akeneo_products();
      });
    },
    get_akeneo_products() {
      const query_params = Object.keys(this.$route.query).map(key => key + '=' + this.$route.query[key]).join('&');

      this.$http.get(`${this.app.api_url}/akeneo/products?${query_params}`).then((response) => {
        this.products = response.data.products;
        this.loading = false;
      });
    },

    isEquivalent(a, b) {
      // Create arrays of property names
      const aProps = Object.getOwnPropertyNames(a);
      const bProps = Object.getOwnPropertyNames(b);

      // If number of properties is different,
      // objects are not equivalent
      if (aProps.length != bProps.length) {
        return false;
      }

      for (let i = 0; i < aProps.length; i++) {
        const propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
          return false;
        }
      }

      // If we made it this far, objects
      // are considered equivalent
      return true;
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/autoload-components/catalog.vue